import clsx from 'clsx';
import { IconProps } from '../../IconProps';

type FirmableIconProps = IconProps & {
  variant?: 'solid' | 'reversed';
};

function FirmableIcon({ width = 36, height = 36, className, variant = 'reversed' }: FirmableIconProps) {
  const isReversed = variant === 'reversed';
  const primaryColor = isReversed ? 'white' : '#D95205';

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={clsx(className)}
    >
      <g clipPath="url(#clip0_firmable_icon)">
        <path
          d="M34.5261 16.1383C35.2291 16.8412 35.2291 17.981 34.5262 18.6839L29.4455 23.7645C28.7426 24.4675 27.6029 24.4675 26.8999 23.7645L18.002 14.8665L22.2339 10.6345C24.1084 8.76003 27.1476 8.76 29.0221 10.6345L34.5261 16.1383Z"
          fill={primaryColor}
          fillOpacity="0.5"
        />
        <path
          d="M21.3959 3.00752C19.5214 1.13308 16.4822 1.13307 14.6077 3.00752L1.47642 16.1386C0.773485 16.8415 0.773482 17.9813 1.47642 18.6842L6.55702 23.7648C7.25996 24.4677 8.39968 24.4677 9.10262 23.7648L18.0018 14.8656L18.0031 14.8668L22.235 10.635C24.1095 8.76045 27.1487 8.76042 29.0233 10.6349L21.3959 3.00752Z"
          fill={primaryColor}
        />
        <path
          d="M16.7293 21.2232C17.4322 20.5202 18.5719 20.5202 19.2749 21.2232L24.359 26.3073C25.062 27.0103 25.062 28.15 24.359 28.8529L19.2749 33.937C18.5719 34.64 17.4322 34.64 16.7293 33.937L11.6452 28.8529C10.9422 28.1499 10.9422 27.0102 11.6452 26.3073L16.7293 21.2232Z"
          fill={primaryColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_firmable_icon">
          <rect width="36" height="36" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export { FirmableIcon };
export type { FirmableIconProps };
